const Types = {
	NEXT_STEP: 'NEXT_STEP',
	PREV_STEP: 'PREV_STEP',
	VALIDATION_STEP: 'VALIDATION_STEP',
	UPDATE_BODY_PART_CUSTOMIZED: 'UPDATE_BODY_PART_CUSTOMIZED',
	UPDATE_INFORMATIONS_CUSTOMIZED: 'UPDATE_INFORMATIONS_CUSTOMIZED',
	SET_FILE: 'SET_FILE',
	CLEAR_REPORTS: 'CLEAR_REPORTS',
	UPDATE_PARAMETERS_CUSTOMIZED: 'UPDATE_PARAMETERS_CUSTOMIZED',
	SET_OPTIONS: 'SET_OPTIONS',
	SET_RISK_DEGREE: 'SET_RISK_DEGREE',
	SET_DATA: 'SET_DATA',
	SET_RANGE_RISK_BANDS: 'SET_RANGE_RISK_BANDS',
	SET_RECOVERY_REPORT: 'SET_RECOVERY_REPORT'
};

export default Types;
